import React from "react";
import { useNavigate } from "react-router-dom";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { PROJECT_MANAGEMENT, PROJECT_BUDGET } from "../../../../../../constants/route-paths";

/**
 * CostBreakdownHeader - Header component for cost breakdown page
 * 
 * SUMMARY:
 * Displays the page title and breadcrumb navigation for the cost breakdown page.
 * Provides navigation back to projects and budget pages.
 * 
 * RESPONSIBILITIES:
 * - Display page title with cost type
 * - Render breadcrumb navigation
 * - Handle navigation to parent pages
 * 
 * PROPS:
 * @param {Object} project - Project object
 * @param {string} project.name - Project name
 * @param {string} costTypeLabel - Label for the cost type (Material, Resource, Subcontractor, All)
 * @param {string} costType - Raw cost type from route
 * @param {string} projectId - Project ID for navigation
 * 
 * COMPONENTS RENDERED:
 * - Breadcrumb: Navigation breadcrumbs
 */
const CostBreakdownHeader = ({ project, costTypeLabel, costType, projectId }) => {
  const navigate = useNavigate();

  const navigateBack = () => {
    navigate(`/${PROJECT_MANAGEMENT}/${PROJECT_BUDGET}`.replace(':projectId', projectId));
  };

  return (
    <div className="row">
      <div className="w-auto">
        <h2 className="content-heading text-uppercase">
          Budget - {costTypeLabel || costType || 'Cost'} Cost Breakdown
        </h2>
        <div className="col-12 breadcrumb-block p-0">
          <Breadcrumb>
            <Breadcrumb.Item onClick={() => navigate(`/${PROJECT_MANAGEMENT}`)}>
              PROJECTS
            </Breadcrumb.Item>
            <Breadcrumb.Item onClick={() => navigate(`/${PROJECT_MANAGEMENT}/view/${projectId}`)}>
              {project?.name || 'Project'}
            </Breadcrumb.Item>
            <Breadcrumb.Item onClick={navigateBack}>
              Budget
            </Breadcrumb.Item>
            <Breadcrumb.Item active>
              {costTypeLabel} Cost Breakdown
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>
    </div>
  );
};

export default CostBreakdownHeader;
